import { styled, Theme, CSSObject } from '@mui/material/styles';
import { drawerWidth } from 'src/shared/contexts/appContext';
import { Colors } from '../../styles/colors';

export const openedMixin = (theme: Theme): CSSObject => ({
  backgroundColor: `${Colors.PageBackground} !important`,
  color: Colors.MenuText,
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  [theme.breakpoints.down('md')]: {
    flexShrink: 1,
    boxShadow: theme.shadows[10],
  },
  overflowX: 'hidden',
  borderRight: 'none',
});

export const closedMixin = (theme: Theme): CSSObject => ({
  backgroundColor: `${Colors.PageBackground} !important`,
  color: Colors.MenuText,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(9)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
  [theme.breakpoints.down('md')]: {
    display: `none !important`,
  },
  borderRight: 'none',
});

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const listMenuStyles = {
  '&.Mui-disabled': {
    pointerEvents: 'auto',
  },
  '& .MuiListItemButton-root': {
    transition: 'background-color 0.15s, color 0.15s',
  },
  '& .MuiListItemButton-root:hover:not(.active)': {
    backgroundColor: 'rgba(20,18,15,0.03)',
  },
  '& .MuiListItemButton-root.active:not(.subMenuItem)': {
    backgroundColor: Colors.White,
    border: '1px solid #dadde1',
    boxShadow: '0 1px 2px rgba(20,18,15,0.04)',
  },
  '& .subMenuText .MuiTypography-root': {
    fontSize: '0.8rem !important',
    fontWeight: 'inherit',
  },
  // Vänster-ikoner i menu items: blå brand-färg (storlek styrs per item via sx för att kunna växla med collapsed/expanded)
  '& .MuiListItemIcon-root:not(.dotIndicator) .MuiSvgIcon-root': {
    color: `${Colors.MenuIcon} !important`,
  },
  // Subitem-dotindikator: blå (override:ar Drawer-default som annars gör dem vita)
  '& .dotIndicator .MuiSvgIcon-root': {
    color: `${Colors.MenuIcon} !important`,
  },
  // Pilar (chevron/expand) som ligger direkt i ListItemButton — text-färg och något mindre
  '& .MuiListItemButton-root > .MuiSvgIcon-root': {
    color: 'rgba(0, 0, 0, 0.87) !important',
    fontSize: '1.1rem',
  },
  '& .subMenuItem': {
    py: 0.25,
    ml: 0.8,
    position: 'relative',
    '&::after': {
      backgroundColor: Colors.LinkColor,
      content: '" "',
      height: '1rem',
      left: '1.25rem',
      opacity: '.5',
      position: 'absolute',
      top: -0.5,
      transform: 'translateY(-50%)',
      width: '1px',
    },
    '&:first-of-type::after': {
      height: '0.5rem',
      top: (thm) => thm.spacing(0.5),
    },
  },
  mx: 1,
};
